/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Shared_Hosting_Etos_ReleaseItemImport_ReleaseItemImportEto } from '../models/Wealthlane_Shared_Hosting_Etos_ReleaseItemImport_ReleaseItemImportEto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ReleaseItemImportEventHandlerService {

    /**
     * @param requestBody
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppReleaseItemImportEventHandlerReleaseItemImportEventHandler(
        requestBody?: Wealthlane_Shared_Hosting_Etos_ReleaseItemImport_ReleaseItemImportEto,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/release-item-import-event-handler/release-item-import-event-handler',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
